module.exports = __webpack_public_path__ + "img/icon-03.b65f913c.png";